import { HorairesDeTravailTab } from "@features/rh/horaires-de-travail/components/HorairesDeTravailTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Clock } from "lucide-react";

export const Route = createFileRoute("/_app/rh/horaires-de-travail/")({
  loader: requirePermission(PERMISSIONS.RH.PLANNING.VIEW),
  staticData: {
    title: "Horaires de travail",
    icon: Clock,
    tab_icon: Clock,
    permission: PERMISSIONS.RH.PLANNING.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 24,
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
    description: "Gestion des horaires de travail",
  },
  component: HorairesDeTravailTab,
});
